import React, { useState, useEffect, useMemo } from 'react';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';
import Classes from './Navbar.module.css';
import Logo from '../Logo/Logo';
import { scrollToElement } from '../../../../utils/scrollToElement';
import ProfileDropDown from './ProfileDropDown';

export default function Navbar() {
    const navigateTo = useNavigate();
    const location = useLocation();
    const [activePage, setActivePage] = useState(location.pathname);

    useEffect(() => {
        setActivePage(location.pathname);
    }, [location.pathname]);

    const [width, setWidth] = useState(
        typeof window !== 'undefined' ? window.innerWidth : 0
    );

    const handleScrollOrNavigate = (id, offset = 0) => {
        if (location.pathname !== '/') {
            navigateTo('/', { state: { scrollTo: { id, offset } } });
        } else {
            scrollToElement(id, offset);
        }
    };

    useEffect(() => {
        function handleResize() {
            setWidth(window.innerWidth);
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const navigateToSignup = () => navigateTo('/signup');
    const navigateTologin = () => navigateTo('/login');

    const isSettingsActive = useMemo(
        () => location.pathname.startsWith('/settings'),
        [location.pathname]
    );

    return (
        <motion.div className={`${Classes.navbar} layoutPadding`} >
            <div className={Classes.gridLeft} >
                <div onClick={() => { navigateTo('/') }} style={{ textDecoration: 'none', cursor: 'pointer' }} >
                    <div>
                        <Logo alwaysShowText={true} />
                    </div>
                </div>
            </div>
            <ul>
                {width >= 400 &&
                    <li
                        className={activePage === '/' ? Classes.navActive : ''}
                    >
                        <div onClick={() => { navigateTo('/') }} style={{ textDecoration: 'none', cursor: 'pointer' }} >
                            <h5> Home </h5>
                        </div>
                    </li>
                }
                <li
                    onClick={() => { navigateTo('/products') }}
                    className={activePage === '/products' ? Classes.navActive : ''}
                >
                    <h5> Products </h5>
                </li>
                <li
                    onClick={() => { navigateTo('/collections') }}
                    className={activePage === '/collections' ? Classes.navActive : ''}
                >
                    <h5> {width >= 600 ? 'My Collections' : 'Collections'} </h5>
                </li>
                {width >= 600 &&
                    <li
                        onClick={() => { navigateTo('/settings/profile') }}
                        className={isSettingsActive ? Classes.navActive : ''}
                    >
                        <h5> Settings </h5>
                    </li>
                }
            </ul>
            <div className={Classes.gridRight}>
                <div className={Classes.ctaRow}>
                    <ProfileDropDown />
                </div>
            </div>
        </motion.div>
    );
}
